export default "__VITE_ASSET__DXfsVbgn__"